import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class EncodeRuleManage {
  // 查询基础规则列表（分页）
  static async getBaseRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`api/std/BaseRule/base-rule-list-pages?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询基础规则列表（不分页）
  static async getAllBaseRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/BaseRule/base-rule-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增基础规则
  static async addBaseRule(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/BaseRule', payload))
    return Callback(err, res)
  }
  // 编辑基础规则
  static async editBaseRule(payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/BaseRule/${payload.id}`, payload))
    return Callback(err, res)
  }
  // 删除基础规则
  static async deleteBaseRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/BaseRule/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 批量导入基础规则
  static async uploadBaseRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/BaseRule/import', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 导出基础规则
  static async exportBaseRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/BaseRule/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 导入模板
  static async getBaseRuleTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/BaseRule/download-template', { responseType: 'blob' })
    )
    return Callback(err, res)
  }

  // 查询编码规则列表
  static async getEncodeRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CodeRule/code-rule-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增编码规则
  static async addEncodeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CodeRule/insert-code-rule', payload)
    )
    return Callback(err, res)
  }
  // 编辑编码规则
  static async editEncodeRule(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/std/CodeRule/code-rule', payload))
    return Callback(err, res)
  }
  // 删除编码规则
  static async deleteEncodeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/CodeRule/code-rule-by-ids', { data: payload })
    )
    return Callback(err, res)
  }
  // 删除编码规则和基础规则关联关系
  static async delEncodeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/CodeRule/code-rule-and-base-rule-association-by-ids', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 编码规则导入模板
  static async getEncodeRuleTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/CodeRule/download-template', { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 编码规则导出
  static async exportEncodeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CodeRule/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 批量导入编码规则
  static async uploadEncodeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CodeRule/import', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 查询属性规则管理列表
  static async getAttributeRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/PropertyRule/property-rule-list-by-name?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增属性规则
  static async addAttributeRule(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/PropertyRule', payload))
    return Callback(err, res)
  }
  // 批量编辑属性规则
  static async editAttributeRule(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/std/PropertyRule/many', payload))
    return Callback(err, res)
  }
  // 批量删除属性规则
  static async deleteAttributeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/PropertyRule/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 下载属性规则导入模板
  static async getAttributeRuleTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/PropertyRule/download-template', { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 批量导入属性规则
  static async uploadAttributeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/PropertyRule/import', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 导出属性规则
  static async exportAttributeRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/PropertyRule/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 获取属性文件枚举信息
  static async getfileTypeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/PropertyRule/property-file-enum-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 查询属性规则明细管理列表
  static async getAttributeDetailRuleList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/PropertyRuleDetail/property-rule-detail-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 新增属性规则明细
  static async addAttributeDetailRule(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/PropertyRuleDetail', payload))
    return Callback(err, res)
  }
  // 编辑属性规则明细
  static async editAttributeDetailRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/PropertyRuleDetail/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除属性规则明细
  static async deleteAttributeDetailRule(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/PropertyRuleDetail/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 查询位号基础属性列表
  static async tagBasePropertys(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/tag-base-property-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询文件注册记录列表
  static async getFileRegisterRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/file_register_record?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 查询文件注册记录列表
  static async getTagRegisterRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag_register_record?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导入属性规则文件
  static async uploadAttrRuleFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/Property_Rule_Detail/imort/property_rule_detail',
        payload.formData
      )
    )
    return Callback(err, res)
  }
  // 对象注册导出
  static async exportTagRegisterRecord(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/tag_register_record/export_list', payload)
    )
    return Callback(err, res)
  }
  // 获取实体类及实体类属性
  static async getClassAndAttribute(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CodeRule/std-class-and-attribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
